import React from 'react';
import SEOHelmet from '../components/shared/SEOHelmet';
import HeroSection from '../components/Landing/HeroSection';
import DemoSection from '../components/Landing/DemoSection';
import ProblemSection from '../components/Landing/ProblemSection';
import HowItWorksSection from '../components/Landing/HowItWorksSection';
import FeaturesSection from '../components/Landing/FeaturesSection';
import TestimonialsSection from '../components/Landing/TestimonialsSection';
import FeaturesDeepDiveSection from '../components/Landing/FeaturesDeepDiveSection';
import FAQSection from '../components/Landing/FAQSection';
import TrustBadgesSection from '../components/Landing/TrustBadgesSection';
import PricingCalculatorSection from '../components/Landing/PricingCalculatorSection';
import LegalComplianceSection from '../components/Landing/LegalComplianceSection';
import ComparisonSection from '../components/Landing/ComparisonSection';
import GuaranteeSection from '../components/Landing/GuaranteeSection';
import UseCasesSection from '../components/Landing/UseCasesSection';
import RoadmapSection from '../components/Landing/RoadmapSection';

import PartnersSection from '../components/Landing/PartnersSection';
import MobileAppSection from '../components/Landing/MobileAppSection';
import BlogSection from '../components/Landing/BlogSection';
import CTASection from '../components/Landing/CTASection';
import FinalCTASection from '../components/Landing/FinalCTASection';

const NewLandingPage: React.FC = () => {
  return (
    <>
      <SEOHelmet pageType="landing" />
      <HeroSection />
      <DemoSection />
      <ProblemSection />
      <HowItWorksSection />
      <FeaturesSection />
      <TestimonialsSection />
      <FeaturesDeepDiveSection />
      <FAQSection />
      <TrustBadgesSection />
      <PricingCalculatorSection />
      <LegalComplianceSection />
      <ComparisonSection />
      <GuaranteeSection />
      <UseCasesSection />
      <RoadmapSection />
      <PartnersSection />
      <MobileAppSection />
      <BlogSection />
      <CTASection />
      <FinalCTASection />
    </>
  );
};

export default NewLandingPage; 